export const LOAD_GAMES = 'LOAD_GAMES';

export const STORE_GAMES = 'STORE_GAMES';
export const STORE_QUESTIONS = 'STORE_QUESTIONS';
export const STORE_QUESTION_OPTIONS = 'STORE_QUESTION_OPTIONS';

export const START_GAME = 'START_GAME';

export const ANSWER_QUESTION = 'ANSWER_QUESTION';
export const GIVE_UP_GAME = 'GIVE_UP_GAME';

export const STORE_CURRENT_GAME = 'STORE_CURRENT_GAME';
export const STORE_CURRENT_QUESTION = 'STORE_CURRENT_QUESTION';
export const STORE_CURRENT_QUESTION_OPTION = 'STORE_CURRENT_QUESTION_OPTION';

export const STORE_MESSAGE = 'STORE_MESSAGE';
